module.exports = __webpack_public_path__ + "static/media/greenUpArrow.b66a2287.svg";